const AUTH_SESSION_HINT_KEY = 'calcium-auth-session-hint';

export function readSessionAuthHint() {
	try {
		return (
			typeof localStorage !== 'undefined' &&
			localStorage.getItem(AUTH_SESSION_HINT_KEY) === '1'
		);
	} catch (_) {
		return false;
	}
}

export function writeSessionAuthHint(hasKnownSession) {
	try {
		if (typeof localStorage === 'undefined') return;
		if (hasKnownSession) {
			localStorage.setItem(AUTH_SESSION_HINT_KEY, '1');
		} else {
			localStorage.removeItem(AUTH_SESSION_HINT_KEY);
		}
	} catch (_) {
		// private mode etc.
	}
}
